import {
  type ProductTechnology,
  productTypePathToProductType
} from '@/domain/Product.ts';
import type { UseRoute } from '../hooks/useRoute';

export default function parseRoute(url: string): UseRoute {
  const path = new URL(url).pathname;
  const [, market, locale, firstPath, productTypePath, technology, slug] =
    path.split('/');

  const inFavorites = firstPath === 'favorites';

  return {
    market,
    channel: 'b2c',
    technology: technology as ProductTechnology,
    productType: productTypePathToProductType(productTypePath || ''),
    productTypePath,
    locale,
    slug,
    inFavorites,
    inPLP: false,
    inPDP: false
  };
}
